/*!
 * (C) Larva.io http://larva.io - Seee LICENSE.md
 */
import { a as assignComponentProps } from './helpers-4516ecbe.js';
import { g as getAppRoot } from './theme-d6db8abf.js';

async function createModal(opts) {
  if (typeof customElements !== 'undefined') {
    await customElements.whenDefined('lar-modal');
    const element = document.createElement('lar-modal');
    assignComponentProps(element, opts);
    // append the overlay element to the document body
    getAppRoot(document).appendChild(element);
    await element.componentOnReady();
    element.addEventListener('larmodaldiddismiss', () => {
      element.remove();
    });
    return element;
  }
  throw new Error('WebComponents not available');
}

export { createModal as c };

//# sourceMappingURL=modal-controller-964badac.js.map